import React, {useState} from 'react';

import {groups, simpleTable} from './mock';
import {descColumn, idColumn, nameColumn} from './columns';

import StyledCustomTableDrydock from './StyledCustomTableDrydock';
import CustomTable from '../../../CoreWrappers/CustomTable';

const CustomTableV2Drydock = () => {
	const [value, setValue] = useState([]);

	const labels = {
		emptyMessage: 'DD There is no data to display',
		show: 'DD Show'
	};

	const renderSSTable = () => {
		const props = {
			id: 'serverSideTable',
			data: simpleTable,
			columns: [idColumn, nameColumn, descColumn],
			defaultColumnSort: 'name',
			pagination: true
		};

		return <CustomTable {...props} />;
	};

	const renderScrollableTable = () => {
		const props = {
			id: 'scrollableTable',
			data: simpleTable,
			columns: [
				{...idColumn, fixed: true},
				nameColumn,
				descColumn,
				nameColumn,
				descColumn,
				nameColumn,
				descColumn,
				nameColumn,
				descColumn
			].map((col) => ({...col, width: '1fr'})),
			defaultColumnSort: 'idColumn',
			scrollableColumns: 3
		};

		return <CustomTable {...props} />;
	};

	const renderPaginationTable = () => {
		const props = {
			id: 'paginationTable',
			pagination: true,
			data: simpleTable,
			columns: [descColumn, idColumn, nameColumn],
			defaultColumnSort: 'nameColumn',
			labels,
			enableBodyScroll: true
		};

		return <CustomTable {...props} />;
	};

	const renderEmptyTable = () => {
		const props = {
			id: 'emptyTable',
			data: [],
			columns: [idColumn, nameColumn, descColumn],
			labels
		};

		return <CustomTable {...props} />;
	};

	const renderSelectableTable = () => {
		const props = {
			id: 'selectableTable',
			data: simpleTable,
			columns: [idColumn, nameColumn, descColumn],
			selected: value,
			onSelect: (items) => setValue([...items])
		};

		return <CustomTable {...props} />;
	};

	const renderSimpleTable = () => {
		const props = {
			id: 'simpleTable',
			data: simpleTable,
			columns: [idColumn, nameColumn, descColumn],
			defaultColumnSort: 'name'
		};

		return <CustomTable {...props} />;
	};

	const renderGroupedTable = () => {
		const props = {
			id: 'groupedTable',
			data: groups,
			columns: [idColumn, nameColumn, descColumn]
		};

		return <CustomTable {...props} />;
	};

	return (
		<StyledCustomTableDrydock className="full">
			{/* {renderSSTable()} */}
			{/* {renderSimpleTable()} */}
			{/* {renderScrollableTable()} */}
			{renderPaginationTable()}
			{/* {renderEmptyTable()} */}
			{/* {renderSelectableTable()} */}
			{/* {renderGroupedTable()} */}
		</StyledCustomTableDrydock>
	);
};

export default CustomTableV2Drydock;
